module.exports = __webpack_public_path__ + "static/fogbugz-3620006b57e0ed81a18256f88c28ff99.svg";